import React, { ReactNode } from "react";
import sanitizeHtml from "sanitize-html";

//NOTE: Is it beneficial to add more specific variations of
//this ie: SanitizedGreenHouseHTML()
export const SanitizedHtml: React.FC<
  {
    dirtyHtml: ReactNode;
    sanitizeHtmlOptions?: sanitizeHtml.IOptions;
  } & React.HTMLAttributes<HTMLDivElement>
> = ({ dirtyHtml, sanitizeHtmlOptions, ...props }) => {
  const __html = sanitizeHtml(String(dirtyHtml), {
    ...sanitizeHtmlOptions,
    allowedTags: [
      ...(sanitizeHtmlOptions?.allowedTags || []),
      "address",
      "article",
      "aside",
      "footer",
      "header",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "hgroup",
      "main",
      "nav",
      "section",
      "blockquote",
      "dd",
      "div",
      "dl",
      "dt",
      "figcaption",
      "figure",
      "hr",
      "li",
      "main",
      "ol",
      "p",
      "pre",
      "ul",
      "a",
      "abbr",
      "b",
      "bdi",
      "bdo",
      "br",
      "cite",
      "code",
      "data",
      "dfn",
      "em",
      "i",
      "kbd",
      "mark",
      "q",
      "rb",
      "rp",
      "rt",
      "rtc",
      "ruby",
      "s",
      "samp",
      "small",
      "span",
      "strong",
      "sub",
      "sup",
      "time",
      "u",
      "var",
      "wbr",
      "caption",
      "col",
      "colgroup",
      "table",
      "tbody",
      "td",
      "tfoot",
      "th",
      "thead",
      "tr",
    ],
    allowedIframeHostnames: [
      ...(sanitizeHtmlOptions?.allowedIframeHostnames || []),
      "www.youtube.com",
    ],
  });

  return <div dangerouslySetInnerHTML={{ __html: __html }} {...props} />;
};
